export default __webpack_public_path__ + "static/media/badawi_3.5a82ad09.jpg";